import {Helmet} from "react-helmet-async";
import {useSiteSettings} from "@/context/SiteSettingsContext";

const SITE_URL = "https://www.kamenyazh.com.ua/";
const SITE_DOMAIN = "https://www.kamenyazh.com.ua";

export function LocalBusinessSchema() {
	const {phone, email, address, telegram, viber} = useSiteSettings();

	const sameAs = [
		telegram || null,
		viber ? `viber://chat?number=%2B${viber}` : null,
	].filter(Boolean);

	const schema = {
		"@context": "https://schema.org",
		"@type": "LocalBusiness",
		name: "Гранітна Майстерня",
		description:
			"Власне виробництво гранітних пам'ятників у Ямполі. Лазерна гравюра, встановлення, благоустрій могил.",
		url: SITE_URL,
		telephone: phone,
		email,
		address: {
			"@type": "PostalAddress",
			streetAddress: address,
			addressLocality: "Ямпіль",
			addressRegion: "Вінницька область",
			addressCountry: "UA",
		},
		openingHoursSpecification: [
			{
				"@type": "OpeningHoursSpecification",
				dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
				opens: "09:00",
				closes: "18:00",
			},
		],
		areaServed: [
			"Ямпіль",
			"Вінницька область",
		],
		foundingDate: "2011",
		sameAs,
	};

	return (
		<Helmet>
			<script type="application/ld+json">{JSON.stringify(schema)}</script>
		</Helmet>
	);
}

export function BreadcrumbSchema({items}) {
	const schema = {
		"@context": "https://schema.org",
		"@type": "BreadcrumbList",
		itemListElement: items.map((item, index) => ({
			"@type": "ListItem",
			position: index + 1,
			name: item.name,
			item: `${SITE_DOMAIN}${item.path}`,
		})),
	};

	return (
		<Helmet>
			<script type="application/ld+json">{JSON.stringify(schema)}</script>
		</Helmet>
	);
}

const serviceSchemas = [
	{
		name: "Виготовлення гранітних пам'ятників",
		description:
			"Власне виробництво гранітних пам'ятників повного циклу. Чорний, сірий, червоний граніт, мармур. Широкий каталог моделей.",
		priceMin: 6000,
	},
	{
		name: "Лазерна гравюра на пам'ятнику",
		description:
			"Лазерне гравіювання портретів, орнаментів та написів на гранітних пам'ятниках. Надзвичайна точність та довговічність.",
		priceMin: 800,
	},
	{
		name: "Встановлення та монтаж пам'ятника",
		description:
			"Виїзд та встановлення пам'ятників по всій Вінницькій області. Бетонування основи, рівне встановлення.",
		priceMin: 0,
	},
	{
		name: "Благоустрій могил",
		description:
			"Цокольні плити, вазони, квіткові клумби, огорожа. Повний комплекс благоустрою під ключ.",
		priceMin: 3500,
	},
	{
		name: "Реставрація пам'ятників",
		description:
			"Відновлення написів та гравюр, очищення, оновлення покриття гранітних пам'ятників.",
		priceMin: 500,
	},
	{
		name: "Індивідуальний дизайн пам'ятника",
		description:
			"Ексклюзивні пам'ятники за вашим ескізом або авторським проєктом майстра.",
		priceMin: null,
	},
];

export function ServicesSchema() {
	const schemas = serviceSchemas.map((s) => ({
		"@context": "https://schema.org",
		"@type": "Service",
		name: s.name,
		description: s.description,
		provider: {
			"@type": "LocalBusiness",
			name: "Гранітна Майстерня",
			address: {"@type": "PostalAddress", addressLocality: "Ямпіль", addressCountry: "UA"},
		},
		areaServed: {"@type": "AdministrativeArea", name: "Вінницька область"},
		...(s.priceMin !== null && {
			offers: {
				"@type": "Offer",
				priceCurrency: "UAH",
				price: s.priceMin,
				priceSpecification: {"@type": "PriceSpecification", minPrice: s.priceMin, priceCurrency: "UAH"},
			},
		}),
	}));

	return (
		<Helmet>
			{schemas.map((schema, i) => (
				<script key={i} type="application/ld+json">
					{JSON.stringify(schema)}
				</script>
			))}
		</Helmet>
	);
}
